export const ELLIPSIS = 'ellipsis';

export type PageListEntry = number | typeof ELLIPSIS;

/**
 * Works out which page numbers to render around the current one.
 *
 * The first and last pages are always present so a crawler can reach both ends
 * of the archive in one hop, however deep it is — docs/07-MIGRATION.md §1
 * counts 121 pages of Georgian posts on the old site.
 *
 * Lives in its own file so `Pagination.tsx` exports only components and React
 * Fast Refresh keeps working.
 */
export function buildPageList(
  currentPage: number,
  lastPage: number,
  siblings: number,
): PageListEntry[] {
  if (lastPage <= 1) {
    return lastPage === 1 ? [1] : [];
  }

  const pages = new Set<number>([1, lastPage]);

  for (let page = currentPage - siblings; page <= currentPage + siblings; page += 1) {
    if (page >= 1 && page <= lastPage) {
      pages.add(page);
    }
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const withGaps: PageListEntry[] = [];

  sorted.forEach((page, index) => {
    const previous = sorted[index - 1];

    if (previous !== undefined && page - previous > 1) {
      withGaps.push(ELLIPSIS);
    }

    withGaps.push(page);
  });

  return withGaps;
}
